"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getOffsetFromPage_1 = __importDefault(require("./getOffsetFromPage"));
var getPageFromOffset_1 = __importDefault(require("./getPageFromOffset"));
function buildDefaultFilterInfo(filterInfo) {
    if (filterInfo === void 0) { filterInfo = {}; }
    var merged = __assign({ 
        // Cast here to work around "'T' could be instantiated with an arbitrary
        // type which could be unrelated to '{}'"
        filter: {}, sort: undefined, pageSize: 20, lastRefreshAt: new Date().getTime(), totalResults: 1, totalPages: 1, offset: 0, page: 1, shouldRunImmediately: false }, filterInfo);
    // If there's a page but no offset, set the offset.
    if (filterInfo.page != null && filterInfo.offset == null) {
        merged.offset = getOffsetFromPage_1.default(filterInfo.page, merged.pageSize);
        // If there's an offset but no page, set the page.
    }
    else if (filterInfo.page == null && filterInfo.offset != null) {
        merged.page = getPageFromOffset_1.default(filterInfo.offset, merged.pageSize);
    }
    return merged;
}
exports.default = buildDefaultFilterInfo;
